import React from 'react';
import classes from '../main.module.css'
import Carousel from "react-grid-carousel";

const members = [
    { name: "Siva", roles: ["Founder", "Developer"], image: "/images/siva.png" },
    { name: "Shanmuga Priya", roles: ["Designer"], image: "/images/priya.png" }
];

const Team = () => {

    const title = 'We solution with the\nOur trusting Member’s'

    return (
        <section id="team" className={classes.Team}>
            <div className={classes.OurTeam}>
                <p data-aos="fade-up">Best Our Member</p>
                <pre data-aos="fade-up" data-aos-delay="100">{title}</pre>
                <div className={classes.Members} data-aos="fade-up" data-aos-delay="200">
                    <div style={{ width: '100%', maxWidth: `${Math.min(members.length, 4) * 300}px`, margin: '0 auto' }}>
                        <Carousel cols={Math.min(members.length, 4)} showDots={members.length > 4} containerStyle={{ paddingBottom: '40px' }}>
                            {members.map((member, index) => (
                                <Carousel.Item key={index}>
                                    <div key={index} className={classes.MembersCard}>
                                        <img src={member.image} alt={member.title} />
                                        <div className={classes.MembersInfo}>
                                            <p>{member.name}</p>
                                            <p>{member.roles.join(" • ")}</p>
                                        </div>
                                    </div>
                                </Carousel.Item>
                            ))}
                        </Carousel>
                    </div>
                </div>
            </div>
        </section>
    )

}

export default Team